import {
  researchPillars as sitePillars,
  researchAgendaIntro as siteAgendaIntro,
} from "../data/researchPillars";
import { phdResearchProjects as siteProjects } from "../data/phdResearchProjects";
import { schoolProjects as siteSchoolProjects } from "../data/schoolprojects";
import { researchProjects as siteResearchProjects } from "../data/researchprojects";
import { otherProjects as siteOtherProjects } from "../data/otherprojects";
import { publications as sitePublications } from "../data/publications";
import { newsItems as siteNews } from "../data/news";
import { features as siteFeatures } from "../data/features";
import { mentoring as siteMentoring } from "../data/mentoring";
import { collaborators as siteCollaborators } from "../data/collaborators";
import {
  awardsAndHonours as siteAwards,
  homePitch as siteHomePitch,
  bioExpandedParagraphs as siteBioExpanded,
  pageCopy as sitePageCopy,
  academicServices as siteAcademicServices,
  personalInterestParagraphs as sitePersonalInterests,
} from "../data/homeContent";
import {
  DEFAULT_ASSOCIATION_TYPES,
  associationTypes as siteAssociationTypes,
} from "../data/associationTypes";
import { ADMIN_IMAGES } from "../admin/media";
import { toEditableProject } from "../utils/prePhdProjects";

/** Canonical draft shape from live site data (Admin + Visual Studio). */
export const buildSiteDraft = () => {
  const imageKeyBySrc = new Map(
    Object.entries(ADMIN_IMAGES).map(([key, src]) => [src, key]),
  );
  return {
    researchPillars: sitePillars,
    researchAgendaIntro: siteAgendaIntro,
    homePitch: siteHomePitch,
    bioExpandedParagraphs: siteBioExpanded,
    phdResearchProjects: siteProjects.map((project) => ({
      ...project,
      img: imageKeyBySrc.get(project.img) || "Placeholder",
      shown: project.shown !== false,
    })),
    schoolProjects: siteSchoolProjects.map(toEditableProject),
    researchProjects: siteResearchProjects.map(toEditableProject),
    otherProjects: siteOtherProjects.map(toEditableProject),
    publications: sitePublications.map((pub) => ({
      ...pub,
      image: imageKeyBySrc.get(pub.image) || undefined,
    })),
    newsItems: siteNews,
    features: siteFeatures,
    mentoring: siteMentoring,
    collaborators: siteCollaborators,
    awardsAndHonours: siteAwards,
    pageCopy: sitePageCopy,
    academicServices: siteAcademicServices,
    personalInterestParagraphs: sitePersonalInterests,
    associationTypes:
      siteAssociationTypes?.length > 0
        ? siteAssociationTypes
        : DEFAULT_ASSOCIATION_TYPES,
  };
};

export const mergeDraftWithSite = (loaded) => {
  const site = buildSiteDraft();
  const base = loaded || {};
  return {
    ...site,
    ...base,
    homePitch: { ...site.homePitch, ...(base.homePitch || {}) },
    researchAgendaIntro: {
      ...site.researchAgendaIntro,
      ...(base.researchAgendaIntro || {}),
    },
    pageCopy: { ...site.pageCopy, ...(base.pageCopy || {}) },
    academicServices: {
      ...site.academicServices,
      ...(base.academicServices || {}),
      reviewing:
        base.academicServices?.reviewing || site.academicServices.reviewing,
      specialRecognition:
        base.academicServices?.specialRecognition ??
        site.academicServices.specialRecognition,
      studentVolunteer:
        base.academicServices?.studentVolunteer ||
        site.academicServices.studentVolunteer,
    },
    personalInterestParagraphs:
      base.personalInterestParagraphs || site.personalInterestParagraphs,
    bioExpandedParagraphs: base.bioExpandedParagraphs || site.bioExpandedParagraphs,
    schoolProjects: base.schoolProjects || site.schoolProjects,
    researchProjects: base.researchProjects || site.researchProjects,
    otherProjects: base.otherProjects || site.otherProjects,
    associationTypes:
      base.associationTypes?.length > 0
        ? base.associationTypes
        : site.associationTypes,
  };
};
